export default __webpack_public_path__ + "static/media/lotus.1bb504c8.svg";